'use strict';

module.exports = {
    getCheckOutDate: function(searchParams) {
        var isRoundTrip = 1 < searchParams.searchSegments.length;
        return searchParams.checkOutDate || (isRoundTrip ?
            searchParams.searchSegments[1].dateStr :
            Odigeo.Utils.getNextDay(searchParams.searchSegments[0].dateStr));
    },

    getHotelDataFromSession: function() {
        var searchParameters = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
        var checkInDate = searchParameters.searchSegments[0].dateStr;
        var checkOutDate = this.getCheckOutDate(searchParameters);
        var visitId = Odigeo.SessionScope.visitId;

        return {
            iata: searchParameters.searchSegments[0].destination.iata,
            checkin_monthday: Odigeo.Utils.formatDate(checkInDate, 'dd', true),
            checkin_year_month: Odigeo.Utils.formatDate(checkInDate, 'yyyy-mm', true),
            checkout_monthday: Odigeo.Utils.formatDate(checkOutDate, 'dd', true),
            checkout_year_month: Odigeo.Utils.formatDate(checkOutDate, 'yyyy-mm', true),
            visitId: visitId,
        };
    },

    getHotelLinkFromSession: function() {
        var data = this.getHotelDataFromSession();
        var link = Odigeo.UIElements.translations.xsellHomePage.homeHotelTabUrl;
        return Odigeo.Utils.replaceCmsKeyArgs(link, data.iata, data.checkin_monthday,
            data.checkin_year_month, data.checkout_monthday, data.checkout_year_month,
            data.visitId);
    },

    addParametersToElementUrl(element, params) {
        if (!element) {
            return;
        }

        let concatChar = null;
        const encodedParams = $.param(params);

        switch (element.tagName.toLowerCase()) {
            case 'iframe':
                concatChar = getConcatCharForQueryParams(element.src);
                element.src = element.src + concatChar + encodedParams;
                break;
            case 'a':
                concatChar = getConcatCharForQueryParams(element.href);
                element.href = element.href + concatChar + encodedParams;
                break;
            case 'li':
                concatChar = getConcatCharForQueryParams(element.dataset.url);
                element.dataset.url = element.dataset.url + concatChar + encodedParams;
                break;
        }
    },

    listenClickOnIframe(el, listener) {
        if (!el) {
            return;
        }

        window.addEventListener('blur', () => {
            setTimeout(() => {
                if (document.activeElement === el) {
                    listener();
                }
            }, 0);
        });
    },
};

function getConcatCharForQueryParams(url) {
    return _.includes(url, '?') ? '&' : '?';
}
